import React from 'react'
import { Label, Table } from 'semantic-ui-react'

import CustomerInfo from '../../components/OrderListItem/CustomerInfo'

export default class CustomerCell extends React.PureComponent {
  render() {
    const { inProgressOrders, order, readOnly } = this.props

    return (
      <Table.Cell textAlign='center'>
        {inProgressOrders > 1 && (
          <Label circular color="orange">
            Order now: {inProgressOrders}
          </Label>
        )}
        <CustomerInfo order={order} readOnly={readOnly} />
      </Table.Cell>
    )
  }
}



// WEBPACK FOOTER //
// ./src/containers/orders/guide/components/CustomerCell.js